module.exports = __webpack_public_path__ + "static/media/uxconf.ec28607e.jpg";